"use client"
import styled from "@emotion/styled"
import Link from "next/link"
import { Container, NewText } from "ui"
import ImageWithAlt from "ui/ImageWithAlt"
import { extractImage } from "utils"
import { extractProperty } from "utils/extractProperty"

const StyledGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 34px;
    row-gap: 40px;
    margin-bottom: 40px;
  }
`

const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  p {
    margin: 0;
  }
`
const StyledButton = styled.button`
  background-color: white;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 200px;
  border: 2px solid #000;
  outline: none;
  margin-left: auto;
  font-size: 16px;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-right: 20%;
    font-size: 18px;
  }
`

type Props = {
  data: any
}
const Community = ({ data }: Props) => {
  const communityBlocks = extractProperty(data, "communityBlocks").map((item: any) => {
    return {
      icon: extractImage(item, "icon"),
      title: extractProperty(item, "title"),
      text: extractProperty(item, "text"),
    }
  })
  const donationButton = extractProperty(data, "donationButton")

  return (
    <Container style={{ padding: "0 10px 40px 10px" }}>
      <StyledGridContainer>
        {communityBlocks.map((i: any, k: number) => (
          <StyledItemContainer key={k.toString()}>
            <ImageWithAlt
              image={i.icon}
              height={32}
              width={32}
              style={{ borderRadius: "50%", marginBlockEnd: "8px" }}
            />
            <NewText
              desktopFontSize={14}
              desktopFontWeight="600"
              desktopLineHeight="110%"
              mobileFontSize={12}
              mobileFontWeight="600"
              mobileLineHeight={"112.5%"}
              component="h1"
              color={"black"}
              margin={0}
              marginBottom={"8px"}
            >
              {i.title}
            </NewText>
            <NewText
              desktopFontSize={14}
              desktopFontWeight="400"
              desktopLineHeight="110%"
              mobileFontSize={12}
              mobileFontWeight="400"
              mobileLineHeight={"20px"}
              component="div"
              color={"black"}
              dangerouslySetInnerHTML={{ __html: i.text }}
              style={{ padding: 0, margin: 0 }}
              maxWidth={"360px"}
              margin={0}
            />
          </StyledItemContainer>
        ))}
      </StyledGridContainer>
      <Link
        href={donationButton[0].url}
        target={donationButton[0].target}
        style={{ textDecoration: "none" }}
      >
        <StyledButton>{donationButton[0].name}</StyledButton>
      </Link>
    </Container>
  )
}
export default Community
